document.querySelectorAll('[data-hero-slider]').forEach(function (slider) {
  var track = slider.querySelector('.hero-slider__track');
  var slides = track.children.length;
  var dotsWrap = slider.querySelector('[data-hero-dots]');
  var current = 0;
  var autoplay = slider.dataset.autoplay !== 'false';
  var speed = parseInt(slider.dataset.speed, 10) || 6000;
  var timer;

  if (dotsWrap) {
    for (var i = 0; i < slides; i++) {
      var dot = document.createElement('button');
      if (i === 0) dot.classList.add('active');
      dot.setAttribute('type', 'button');
      dot.addEventListener('click', (function (idx) { return function () { goTo(idx); }; })(i));
      dotsWrap.appendChild(dot);
    }
  }

  function render() {
    track.style.transform = 'translateX(-' + current * 100 + '%)';
    if (dotsWrap) {
      Array.prototype.forEach.call(dotsWrap.children, function (d, i) {
        d.classList.toggle('active', i === current);
      });
    }
  }
  function goTo(i) { current = (i + slides) % slides; render(); }
  function move(dir) { goTo(current + dir); }

  var prevBtn = slider.querySelector('[data-hero-prev]');
  var nextBtn = slider.querySelector('[data-hero-next]');
  if (prevBtn) prevBtn.addEventListener('click', function () { move(-1); });
  if (nextBtn) nextBtn.addEventListener('click', function () { move(1); });

  function startAutoplay() {
    if (!autoplay || slides < 2) return;
    timer = setInterval(function () { move(1); }, speed);
  }
  startAutoplay();
  slider.addEventListener('mouseenter', function () { clearInterval(timer); });
  slider.addEventListener('mouseleave', startAutoplay);
});
